import { ref, watch, inject } from 'vue';

export function useDisableCityField(type) {
  const { subscriberDisableExistingFields = {}, companyDisableExistingFields = {} } = inject('step2') || {};
  const disableCityField = ref(type === 'subscriber' ? subscriberDisableExistingFields.value : companyDisableExistingFields.value);

  watch(subscriberDisableExistingFields, () => {
    disableCityField.value = subscriberDisableExistingFields.value;
  });

  watch(companyDisableExistingFields, () => {
    disableCityField.value = companyDisableExistingFields.value;
  });

  return {
    disableCityField,
  };
}
 